import { Component } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { EmrListComponent } from '../../../../shared/emr-list/emr-list.component';
import { PsychosocialAssessment } from 'src/app/calvin-emr-shared/models/assessments/psychosocial.model';

@Component({
  selector: 'app-psychosocial-info',
  template: `
    <div class="assessment-container">
      <assessment-row title="Mood" [historyMode]="true">
        <emr-list [list]="data().mood" emptyText="N/A"></emr-list>
      </assessment-row>
      <assessment-row title="Suicidal Thoughts/Expression" [historyMode]="true">
        <p>{{ isSuicidal }}</p>
      </assessment-row>
      <assessment-row title="Other Findings" [historyMode]="true">
        <p>{{ data().otherFindings || 'N/A' }}</p>
      </assessment-row>
    </div>
  `,
  styles: [`
    .assessment-container {
      padding-top: 1.5rem !important;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  `],
  standalone: true,
  imports: [AssessmentRowComponent, EmrListComponent],
})
export class PsychosocialInfoComponent extends AssessmentInfoComponent<PsychosocialAssessment> {
  get isSuicidal() {
    return this.data().suicidal ? 'Yes' : 'No';
  }
}
